import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["previewContainer", "selectContainer", "previewLabel", "select"];

  connect() {
    this.selectContainerTarget.classList.add("hidden");
    this.syncValue();
  }

  changeSelect() {
    this.syncValue();
    this.showPreview();
  }

  showPreview() {
    this.selectContainerTarget.classList.add("hidden");
    this.previewContainerTarget.classList.remove("hidden");
  }

  showSelect() {
    this.selectContainerTarget.classList.remove("hidden");
    this.previewContainerTarget.classList.add("hidden");
  }

  syncValue() {
    const selectValue = this.selectTarget.selectedIndex;
    const selectLabel = this.selectTarget.options[selectValue].innerHTML;

    this.previewLabelTarget.innerHTML = selectLabel;
  }
}
